import { useQuery } from '@tanstack/react-query';

import { OrgFilterItem } from '../../types';
import { BASE_ORG_API } from '../../utils/constants';
import { convertFilterArrayToObject } from '../../utils/driveUtil';
import { fetchWithAuth } from '../../utils/requests';

const fetchArchitectSceneCreatorOptions = async (
  orgId: number
): Promise<Record<string, string[]>> => {
  const response = await fetchWithAuth(
    `${BASE_ORG_API}/${orgId}/architect_scene_values/?field_name=created_by`
  );
  if (!response.ok) {
    throw new Error('Failed to load architect scene filter options');
  }
  const json = (await response.json()) as OrgFilterItem[];
  return convertFilterArrayToObject(json);
};

export const useArchitectSceneFilterOptions = (orgId: number | undefined) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['architect-scene-filter-options', orgId],
    queryFn: () => fetchArchitectSceneCreatorOptions(orgId as number),
    staleTime: Infinity,
    gcTime: 900000,
    enabled: !!orgId,
  });

  return { filterOptions: data ?? {}, isLoading, isError };
};
